var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEdit = function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M29.18 6.585a1.996 1.996 0 0 0-2.822 0L6.292 26.65a1 1 0 0 0-.292.727l.114 5.531a1 1 0 0 0 .978.978l5.531.114c.272.005.535-.1.727-.292l20.065-20.066c.78-.78.78-2.043 0-2.823zM9.012 28.165l.057 2.767 2.766.057 2.405-2.405-2.823-2.823z",
    clipRule: "evenodd"
  })));
};
export default SvgIconEdit;